import { render } from "./Multiselect.vue?vue&type=template&id=3bb995eb"
import script from "./Multiselect.vue?vue&type=script&lang=js"
export * from "./Multiselect.vue?vue&type=script&lang=js"

import "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&external"
import "./Multiselect.vue?vue&type=style&index=1&id=3bb995eb&lang=css"
/* custom blocks */
import block0 from "./Multiselect.vue?vue&type=custom&index=0&blockType=div&class=multiselect__content-wrapper&tabindex=-1&style=max-height%3A%20300px%3B"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__